<script lang="ts">
    import {onMount} from "svelte";
    import TextValueType from "./value-type/TextValueType.svelte";
    import BetweenValueType from "./value-type/BetweenValueType.svelte";
    import StyleSelector from "./StyleSelector.svelte";
    import NonValueType from "./value-type/NonValueType.svelte";
    import {MappedConditionOptions} from "../types";
    import TypeSelector from "./TypeSelector.svelte";
    import {getTranslation} from "../helper/translation";
    import DateValueType from "./value-type/DateValueType.svelte";
    import NumberValueType from "./value-type/NumberValueType.svelte";

    export let value = [];
    export let inputElement: HTMLInputElement = document.createElement('input');
    export let conditions: MappedConditionOptions = null;

    let i18n = getTranslation();

    const getInputForType = (condition: string, operator: string) => {
        let matchedCondition = conditions.find(c => {
            return c.operator === operator;
        });

        if (!matchedCondition) {
            return TextValueType;
        }

        if( matchedCondition.type ==='relative'){
            return NonValueType;
		}

        switch (matchedCondition.value) {
            case 'within_days':
            case 'less_than':
            case 'less_than_equal':
            case 'greater_than':
            case 'greater_than_equal':
            	return NumberValueType;
            case 'date_is':
            case 'date_is_after':
            case 'date_is_before':
                return DateValueType;
            case 'between':
                return BetweenValueType;
            default:
                return TextValueType
        }

    }

    const onDelete = (item) => value = value.filter(d => item != d);

    const addNew = () => {
        let newItem = {
            format: {},
			conditions: {
                relation: 'OR',
                operators: [
                    { operator: conditions[0].operator }
				]
			}
        };
        value = [...value, newItem];
    }

    $: if (value) {
        inputElement.value = JSON.stringify(value);
    }

    onMount(() => {
        if (value.length === 0) {
            addNew();
        }
    });
</script>
<div>
	<div class="acp-cf-conditions">
		{#each value as item}
			{@debug item}
			<div class="acp-cf-conditions__row">
				<div class="acp-cf-conditions__row__item -type">
					<TypeSelector bind:operator={item.conditions.operators[0].operator} bind:config={conditions}></TypeSelector>
				</div>
				<div class="acp-cf-conditions__row__item -value">
					<svelte:component this={getInputForType(item.condition, item.conditions.operators[0].operator )} bind:value={item.conditions.operators[0].fact}/>
				</div>
				<div class="acp-cf-conditions__row__item -style">
					<StyleSelector bind:value={item.format}></StyleSelector>
				</div>
				<div class="acp-cf-conditions__row__item -delete">
					<span class="dashicons dashicons-remove acp-cf-delete-btn" on:click|preventDefault={() => onDelete(item)}></span>
				</div>
			</div>
		{/each}
		<div class="acp-cf-conditions__row">
			<span on:click|preventDefault={addNew} class="ac-btn-link">{i18n.add_another_condition}</span>
		</div>
	</div>


	<div style="margin-top: 10px; background: #eee; font-family: monospace; font-size: 12px;">
		{value ? JSON.stringify( value ) : ''}
	</div>

</div>